export const NOTIFICATIONS_SUBSCRIBE_MODAL_NAME = 'notificationsSubscribe';
